import { Action, ActionFn, defaultActions } from '#/common/components/DataGrid';
import { CapitalNeed } from '#/graphql/types';

export const selectedActions: ActionFn<CapitalNeed>[] = [
  {
    key: 'delete-capital-needs',
    icon: 'trash',
    text: 'Delete',
  },
];

export const actions: Action<CapitalNeed>[] = [...defaultActions];
